export default "__VITE_ASSET__EUL12Tid__"